export enum Decision_Constants {
  Keep_Existing_Property = 1,
  Accept = 2,
  Follow_Up = 3,
  Modify = 4,
}

export enum Flows {
  Audit = 'audit',
  Read_Only = '1',
  Localhost = 'localhost',
  Textrequest = 'TextRequest',
}
